import ApiService from './api-base';
import setApiHeaders from '@/utils/set-api-headers';

const apiService = new ApiService({
	baseUrlConfigName: 'app/VUE_APP_OPEN_AI',
	requestInterceptors: setApiHeaders
});

export default apiService;
